import { FieldValidation } from '@rjsf/utils';
import { ConfigurationItem } from './ConfigurationItemPickerExtension';

export const validateConfigurationItem = (
  ci: ConfigurationItem | undefined,
  validation: FieldValidation,
) => {
  if (ci === undefined) return;
  if (!ci?.appId || !ci?.name) {
    validation.addError('Please select a valid configuration item');
  }
};
